import { LogLevel, type Configuration } from '@azure/msal-browser';

const tenantId = import.meta.env.VITE_AZURE_TENANT_ID ?? '';
const clientId = import.meta.env.VITE_AZURE_CLIENT_ID ?? '';
const apiScope = import.meta.env.VITE_MARZANO_API_SCOPE ?? 'api://marzano-api/access';

if (!tenantId || !clientId) {
  console.error(
    '[msal] Faltan VITE_AZURE_TENANT_ID / VITE_AZURE_CLIENT_ID en el entorno.',
  );
}

export const msalConfig: Configuration = {
  auth: {
    clientId,
    authority: `https://login.microsoftonline.com/${tenantId}`,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    // sessionStorage vs localStorage: reduce ventana de XSS al costo de "recordarme".
    cacheLocation: 'sessionStorage',
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message) => {
        if (level === LogLevel.Error) console.error('[msal]', message);
      },
      logLevel: LogLevel.Warning,
    },
  },
};

export const loginRequest = {
  scopes: [apiScope, 'User.Read', 'openid', 'profile'],
};

// acquireTokenSilent solo pide el scope del API; Graph ya vino en el login.
export const apiTokenRequest = {
  scopes: [apiScope],
};
